import React from 'react';

export const MIN_MARGIN_PCT = 35;

export const fmtEuro = (n) =>
    (Number(n) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const CATEGORIES = [
    { value: 'materiau', label: 'Matériau' },
    { value: 'sous_traitant', label: 'Sous-traitance' },
    { value: 'main_oeuvre', label: "Main d'œuvre" },
    { value: 'autre', label: 'Autre' }
];

export const CATEGORY_LABEL = Object.fromEntries(CATEGORIES.map((c) => [c.value, c.label]));

export const Kpi = ({ label, value, tone, icon }) => (
    <div className="border border-[#E4E4E7] p-4 rounded-sm">
        <div className="text-xs text-[#52525B] uppercase tracking-wide flex items-center gap-1">
            {label} {icon}
        </div>
        <div
            className={`text-lg font-bold mt-1 ${tone === 'warn' ? 'text-red-600' : tone === 'ok' ? 'text-[#16A34A]' : 'text-[#0A0A0A]'}`}
        >
            {value}
        </div>
    </div>
);
